import React from 'react';
import img from '../../../assets/icons/payment-logos/paypal.svg';
const Paypal = () => {
  return (
    <img src={img} alt="/" />
  );
}

export default Paypal;
